<template>
  <v-img
    src="/img/auth-laptop-background.svg"
    lazy-src="/img/auth-laptop-background.svg"
    width="60%"
    max-height="100vh"
    content-class="laptop-background"
    cover
  >
    <v-img
      src="/img/auth-laptop-and-logos.svg"
      lazy-src="/img/auth-laptop-and-logos.svg"
      max-height="72.5%"
    />
  </v-img>
</template>

<style lang="scss">
  @use '../../../assets/styles/theme' as *;

  .laptop-background {
    padding-top: 115px;
  }
</style>
